"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentTotal_1 = __importDefault(require("./models/PaymentTotal"));
var Payment_1 = __importDefault(require("./models/Payment"));
var to_fixed_1 = __importDefault(require("./utils/to-fixed"));
var Calculator = /** @class */ (function () {
    function Calculator() {
    }
    Calculator.calculate = function (loan) {
        loan.payments = this.calculatePayments(loan);
        loan.total = this.calculatePaymentTotal(loan);
        loan.monthlyPayment = this.getMonthlyPayment(loan.payments);
    };
    Calculator.getMonthlyPayment = function (payments) {
        if (payments.length < 1) {
            throw new Error('payments are empty');
        }
        var firstEl = payments[0];
        if (firstEl.totalPayment === undefined || firstEl.totalPayment === null) {
            throw new Error('invalid payment object');
        }
        return firstEl.totalPayment;
    };
    Calculator.calculatePaymentTotal = function (loan) {
        var principle = loan.amount - loan.downPayment;
        var total = Calculator.calculateTotal(loan);
        var interest = total - principle;
        return new PaymentTotal_1.default(interest, principle, total);
    };
    Calculator.calculateTotal = function (loan) {
        var sum = 0;
        for (var _i = 0, _a = loan.payments; _i < _a.length; _i++) {
            var payment = _a[_i];
            sum += payment.totalPayment;
        }
        return to_fixed_1.default(sum, 2);
    };
    Calculator.calculatePayments = function (loan) {
        var result = [];
        var currentPrinciple = loan.amount - loan.downPayment;
        var totalPaymentPerPeriod = this.totalPaymentPerPeriod(loan);
        var interestCumulative = 0;
        for (var i = 0; i < loan.years * loan.paymentsPerYear; i++) {
            var interestPaymentPerPeriod = this.interestPaymentPerPeriod(loan, currentPrinciple);
            interestCumulative += interestPaymentPerPeriod;
            interestCumulative = to_fixed_1.default(interestCumulative, 2);
            var principlePaid = totalPaymentPerPeriod - interestPaymentPerPeriod;
            currentPrinciple -= principlePaid;
            currentPrinciple = to_fixed_1.default(currentPrinciple, 2);
            var payment = new Payment_1.default(i + 1, totalPaymentPerPeriod, principlePaid, interestPaymentPerPeriod, currentPrinciple, interestCumulative);
            result.push(payment);
        }
        var lastPayment = result[result.length - 1];
        lastPayment.rebalance();
        return result;
    };
    Calculator.interestPaymentPerPeriod = function (loan, principle) {
        var amount = principle * (loan.interest / loan.paymentsPerYear / 100);
        return to_fixed_1.default(amount, 2);
    };
    Calculator.ratePerPeriod = function (interestRate, paymentsPerYear) {
        return interestRate / paymentsPerYear / 100;
    };
    Calculator.interestPowerMultiplier = function (ratePerPeriod, paymentsPerYear, years) {
        return Math.pow(1 + ratePerPeriod, paymentsPerYear * years);
    };
    Calculator.totalPaymentPerPeriod = function (loan) {
        var loanAmount = loan.amount - loan.downPayment;
        var rate = this.ratePerPeriod(loan.interest, loan.paymentsPerYear);
        var multiplier = this.interestPowerMultiplier(rate, loan.paymentsPerYear, loan.years);
        return to_fixed_1.default((loanAmount * (rate * multiplier)) / (multiplier - 1), 2);
    };
    Calculator.calculatePrinciple = function (monthlyPayment, interest, years, paymentsPerYear) {
        // M = P[r(1+r)^n/((1+r)^n)-1)]
        var n = years * paymentsPerYear;
        var r = interest / 100 / paymentsPerYear;
        var powerI = Math.pow(1 + r, n);
        return to_fixed_1.default((monthlyPayment * (powerI - 1)) / (r * powerI), 2);
    };
    return Calculator;
}());
exports.default = Calculator;
